import { useCallback, useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import { DataSourceTable } from 'src/applications/Embed/components/DataSourceTable'
import { Content } from 'src/applications/Embed/elements/LayoutElements'
import { Footer, FooterButton } from 'src/applications/Embed/fragments/Footer'
import { Header } from 'src/applications/Embed/fragments/Header'
import { EmbedLayout } from 'src/applications/Embed/fragments/Layout'
import { IScenePayload, SCENE } from 'src/applications/Embed/types/IScene'
import { useMapDataSourceAndDataTemplateMutation } from 'src/queries/hooks/useMapDataSourceAndDataTemplateMutation'
import { QueryAlert } from 'src/resources/elements/QueryAlert'
import { useTranslation } from 'react-i18next'

export function DataSourceScene({ batch, onComplete }: IScenePayload) {
  const [selected, setSelected] = useState<number>()
  const [mapDataSource, { loading }] = useMapDataSourceAndDataTemplateMutation()
  const { t } = useTranslation()
  const { addToast } = useToasts()

  const handleComplete = useCallback(async () => {
    try {
      const {
        data: { mapDataSourceAndDataTemplate }
      } = await mapDataSource({
        variables: {
          viewId: batch.viewId,
          uploadId: batch.uploadId,
          schemaId: parseInt(batch.schemaId, 10),
          index: selected
        }
      })

      if (!mapDataSourceAndDataTemplate.success) {
        // TODO - figure out what these errors are and if/how to translate
        // basically, is this error what gets displayed a few lines down
        throw new Error('Unable to select sheet, please try again later')
      }

      onComplete({
        dataSourceIndex: selected
      })
    } catch ({ message }) {
      // TODO - figure out what these errors are and if/how to translate
      addToast(message, {
        appearance: 'error',
        autoDismiss: true
      })
    }
  }, [selected, batch])

  if (!batch?.uploadDataSources?.length) {
    // TODO - figure out what these errors are and if/how to translate
    return QueryAlert({ error: 'No sheets found in file' })
  }

  return (
    <EmbedLayout>
      <Content>
        <Header scene={SCENE.SOURCE} />
        <DataSourceTable
          uploadDataSources={batch.uploadDataSources}
          selected={selected}
          onChange={setSelected}
        />
      </Content>
      <Footer boxShadow>
        <FooterButton
          disabled={!Number.isInteger(selected) || loading}
          onClick={handleComplete}
          embeds
        >
          <span>{t('elements.buttons.continue')}</span>
        </FooterButton>
      </Footer>
    </EmbedLayout>
  )
}
